/** External link from the Mini App: Telegram opens it in the in-app browser, otherwise a new tab. */
export function openExternal(url) {
  if (!url) return;
  const tg = window?.Telegram?.WebApp;
  if (tg?.openLink) {
    tg.openLink(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
